// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const HookInstanceList = lazy(() => import('pages/hookInstance/list'));
const HookInstanceShow = lazy(() => import('pages/hookInstance/show'));

const HookInstanceRoute = (
  <Route path={routeName.hookInstance}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.HOOK_INSTANCE_VIEW,
            PrivateRouteConst.SELF_HOOK_INSTANCE_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <HookInstanceList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        // <PrivateRoute
        //   name={[
        //     PrivateRouteConst.HOOK_INSTANCE_VIEW,
        //     PrivateRouteConst.SELF_HOOK_INSTANCE_VIEW,
        //   ]}
        // >
        <Suspense fallback={<Loading />}>
          <HookInstanceShow />
        </Suspense>
        //  </PrivateRoute>
      }
    />
  </Route>
);

export default HookInstanceRoute;
